<div class="flex items-center justify-between my-sm">
  <div class="flex items-center gap-xl">
    @if (showChangeSize()) {
      <ul class="flex justify-center gap-sm">
        <li class="flex flex-col items-center justify-center text-xs2">
          <span>{{ sizeOptionsLabel() }}</span>
        </li>

        @for (size of sizeOptions(); track $index) {
          <li class="flex flex-col items-center justify-center">
            <a
              class="justify-center items-center text-xs2 w-full rounded-sm"
              [class]="pageBtnStyle()"
              [attr.aria-current]="size === currentSize() ? 'size' : null"
              [attr.aria-label]="
                size === currentSize()
                  ? 'Current size, size ' + size
                  : 'Go to Size ' + size
              "
              [class.current]="size === currentSize()"
              tabindex="0"
              (click)="changeSize(size)">
              {{ size }}</a
            >
          </li>
        }
      </ul>
    }
    @if (showing(); as showing) {
      <span data-paginator-summary class="text-xs2 text-neutral-500">
        {{
          'pagination_showing_summary'
            | transloco: { count: showing.count, total: showing.total }
        }}
      </span>
    }
  </div>

  <nav class="flex items-center" aria-label="pagination">
    <ul class="flex justify-center gap-sm">
      <li class="flex flex-col items-center justify-center">
        <button
          type="button"
          class="text-xs2 rounded-sm px-lg py-sm flex items-center gap-sm"
          aria-label="Go To Previous Page"
          [attr.aria-disabled]="currentPage() === 1"
          [class.opacity-30]="currentPage() === 1"
          [disabled]="currentPage() === 1"
          (click)="onPrevious()">
          @if (getPreviousIcon()) {
            <lib-chevron-down-icon
              [iconClass]="'size-4 text-neutral-500 rotate-90'" />
          }
          {{ previousBtnLabel() }}
        </button>
      </li>

      @for (page of pages; track $index) {
        <li class="flex flex-col items-center justify-center">
          <a
            class="justify-center items-center text-xs2 w-full rounded-sm"
            [class]="pageBtnStyle()"
            [attr.aria-current]="page === currentPage() ? 'page' : null"
            [attr.aria-label]="
              page === currentPage()
                ? 'Current Page, Page ' + page
                : 'Go to Page ' + page
            "
            [class.current]="page === currentPage()"
            [class.disable]="page < 0"
            tabindex="0"
            (click)="onGoTo(page)"
            [attr.aria-disabled]="page < 0">
            {{ page > 0 ? page : '...' }}</a
          >
        </li>
      }

      <li class="flex flex-col items-center justify-center">
        <button
          type="button"
          class="text-xs2 rounded-sm px-lg py-sm flex items-center gap-sm"
          aria-label="Go To Next Page"
          [attr.aria-disabled]="currentPage() === totalPages()"
          [class.opacity-30]="currentPage() === totalPages()"
          [disabled]="currentPage() === totalPages()"
          (click)="onNext()">
          <span> {{ nextBtnLabel() }} </span>
          @if (getNextIcon()) {
            <lib-chevron-down-icon
              [iconClass]="'size-4 text-neutral-500 rotate-270'" />
          }
        </button>
      </li>
    </ul>
  </nav>
</div>
